var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeyboAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68543 3.1582C5.47756 3.1582 2.06641 6.63259 2.06641 10.9185C2.06641 15.2043 5.47756 18.6787 9.68543 18.6787C11.4461 18.6787 13.0673 18.0704 14.3575 17.0489L19.4882 22.2747C19.8601 22.6536 20.4631 22.6536 20.835 22.2747C21.2069 21.8959 21.2069 21.2817 20.835 20.9029L15.7043 15.6771C16.7072 14.363 17.3045 12.7118 17.3045 10.9185C17.3045 6.63259 13.8933 3.1582 9.68543 3.1582ZM3.97116 10.9185C3.97116 7.70406 6.52953 5.09827 9.68543 5.09827C12.8413 5.09827 15.3997 7.70406 15.3997 10.9185C15.3997 14.1329 12.8413 16.7387 9.68543 16.7387C6.52953 16.7387 3.97116 14.1329 3.97116 10.9185Z",
    fill: "url(#paint0_linear_17180_5694)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0761 0.849212L21.6707 2.42376C21.7674 2.67981 21.8157 2.80784 21.8909 2.91553C21.9575 3.01097 22.0394 3.09436 22.1331 3.16222C22.2388 3.2388 22.3645 3.28804 22.6159 3.38652L24.1618 3.99212L22.6159 4.59771C22.3645 4.69619 22.2388 4.74543 22.1331 4.82201C22.0394 4.88987 21.9575 4.97326 21.8909 5.06871C21.8157 5.17639 21.7674 5.30442 21.6707 5.56047L21.0761 7.13502L20.4815 5.56047C20.3848 5.30442 20.3365 5.17639 20.2613 5.06871C20.1947 4.97326 20.1128 4.88987 20.0191 4.82201C19.9134 4.74543 19.7877 4.69619 19.5363 4.59771L17.9904 3.99212L19.5363 3.38652C19.7877 3.28804 19.9134 3.2388 20.0191 3.16223C20.1128 3.09436 20.1947 3.01097 20.2613 2.91553C20.3365 2.80784 20.3848 2.67981 20.4815 2.42376L21.0761 0.849212Z",
    fill: "url(#paint1_linear_17180_5694)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1618 7.48423V5.73817M18.1618 2.24606V0.5M17.3047 1.37303H19.019M17.3047 6.6112H19.019M21.0761 0.849212L20.4815 2.42376C20.3848 2.67981 20.3365 2.80784 20.2613 2.91553C20.1947 3.01097 20.1128 3.09436 20.0191 3.16222C19.9134 3.2388 19.7877 3.28804 19.5363 3.38652L17.9904 3.99212L19.5363 4.59771C19.7877 4.69619 19.9134 4.74543 20.0191 4.82201C20.1128 4.88987 20.1947 4.97326 20.2613 5.0687C20.3365 5.17639 20.3848 5.30442 20.4815 5.56047L21.0761 7.13502L21.6707 5.56047C21.7674 5.30442 21.8157 5.17639 21.8909 5.0687C21.9575 4.97326 22.0394 4.88987 22.1331 4.82201C22.2388 4.74543 22.3645 4.69619 22.6159 4.59771L24.1618 3.99212L22.6159 3.38652C22.3645 3.28804 22.2388 3.2388 22.1331 3.16222C22.0394 3.09436 21.9575 3.01097 21.8909 2.91553C21.8157 2.80784 21.7674 2.67981 21.6707 2.42376L21.0761 0.849212Z",
    stroke: "url(#paint2_linear_17180_5694)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17180_5694",
    x1: 22.6463,
    y1: -3.63202,
    x2: -1.61922,
    y2: 32.1865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.281884,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499787,
    stopColor: "#6123E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17180_5694",
    x1: 22.9961,
    y1: 0.220622,
    x2: 17.7226,
    y2: 7.88325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7745E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17180_5694",
    x1: 22.9961,
    y1: 0.220622,
    x2: 17.7226,
    y2: 7.88325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#7745E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#60E25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5AC3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#22FFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeyboAi);
export default __webpack_public_path__ + "static/media/heybo-ai.d82bd91a78e8a1d64678453cad27260d.svg";
export { ForwardRef as ReactComponent };